// extracted by mini-css-extract-plugin
module.exports = {"Search":"search_Search__2mWNL","formError":"search_formError__UAWCV","spindindust":"search_spindindust__RSZIW"};